enum WarrantyStatus {
  NEW = 10,
  BEING_HANDLED = 20,
  HANDLED = 30
}

export default WarrantyStatus;